import React, { Fragment, useState, useEffect } from 'react';
import * as ReactDOM from 'react-dom/client';
import './index.scss';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'; // ✅ Use Routes instead of Switch
import Loader from './layout/loader';
import { Provider } from 'react-redux';
import store from './store';
import App from './components/app';

// Import pages
import Signin from './auth/signin';
import Error400 from "./pages/errors/error400";
import Error401 from "./pages/errors/error401";
import Error403 from "./pages/errors/error403";
import Error404 from "./pages/errors/error404";
import Error500 from "./pages/errors/error500";
import Error503 from "./pages/errors/error503";
import { routes } from './route';
import { QueryClient, QueryClientProvider } from 'react-query';
import axios from 'axios';

const Root = () => {

  axios.defaults.baseURL = "https://lsreport.shls.care/api";

  const [authorized, setAuthorized] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const verifyUser = async () => {
    const token = document.cookie.split(`jwt=`).pop().split(';').shift();
    const request = {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        'Authorization': `Bearer ${token}`,
      }
    };
    try {
      setIsLoading(true);
      let response = await fetch("https://lsreport.shls.care/api/verify", request);
      setIsLoading(false);
      return response.status === 200;
    } catch (err) {
      setIsLoading(false);
      return false;
    }
  };

  useEffect(() => {
    verifyUser().then((data) => setAuthorized(data));
  }, []);

  const queryClient = new QueryClient();

  return (
    <Fragment>
      <Loader isLoading={isLoading} />
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Signin />} />
              <Route path="/pages/errors/error400" element={<Error400 />} />
              <Route path="/pages/errors/error401" element={<Error401 />} />
              <Route path="/pages/errors/error403" element={<Error403 />} />
              <Route path="/pages/errors/error404" element={<Error404 />} />
              <Route path="/pages/errors/error500" element={<Error500 />} />
              <Route path="/pages/errors/error503" element={<Error503 />} />

              {authorized ? (
                <>
                  <Route path="/" element={<Navigate to="/dashboard/default/" />} />
                  {routes.map(({ path, Component }) => (
                    <Route key={path} path={path} element={<App><Component /></App>} />
                  ))}
                </>
              ) : (
                <Route path="*" element={<Signin />} />
              )}
            </Routes>
          </BrowserRouter>
        </Provider>
      </QueryClientProvider>
    </Fragment>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

